import tools from "../../../../assets/javascript/tools.js";
export default {
    columns: {
        shopIdCn: {
            label: "建档门店",
            visible: true,
            width: "200",
            align: "left",
        },
        staffIdCn: {
            label: "建档技师",
            visible: true,
            width: "100",
            align: "left",
        },
        amount: {
            label: "金额",
            visible: true,
            width: "100",
            align: "left",
        },
        repairStatusCn: {
            label: "状态",
            visible: true,
            width: "auto",
            align: "left",
        },
        nextRepairTime: {
            label: "下次修护时间",
            visible: true,
            formatDay: true,
            width: "160",
            align: "left",
        },
        // payTime: {
        //     label: "支付时间",
        //     visible: true,
        //     formatDay: true,
        //     width: "160",
        //     align: "left",
        // },
    },
};